import React from 'react'
import { Image } from 'react-bootstrap';
import mezoterapi from '../../images/home/product_cat/16002485293517.jpg';
import '../../styles/about.css'

const Mezoterapi = () => {
    return (
        <div>
            <h5 className='main-title'>Mezoterapi Uygulamaları</h5>
            <hr />
            <p>Diyet ve egzersizle birlikte uygulandığında istenilen sonucu veren mezoterapi, 1952 den bu yana kullanılıyor. Kilo vermeye, selülite ve saç dökülmesine karşı etkili yöntem, cilt yaşlanması, bölgesel yağ erimesi, yara izlerinin tedavisinde...</p>
            <p>Mezoterapi; kelime olarak orta deri tedavisi anlamına gelmektedir. Mezoterapinin temeli, tedavi edilecek bölgeye 4-6 mm uzunluğunda çok ince iğneler kullanılarak çok küçük miktarlarda ilaçları lokal olarak enjekte etmeye dayanan tamamen tıbbi bir eylemdir. Mezoterapi, uzun zamandan beri estetik tıpta en sık talep konusu olan lipodistrofi veya selülit konusunda en seçkin tedavi biçimini oluşturmaktadır.</p>
            <Image src={mezoterapi} fluid className='mb-4' style={{ width: '70%' }} />
            <p>Fransa’ da ortalama 15.000 doktor, günde 60.000 den fazla hastayı mezoterapi yöntemi ile tedavi etmektedir. Uluslararası Mezoterapi Derneği’ne üye olan Avrupa, Afrika ve Güney Amerika’da 14 ülkede yöntem başarı ile uygulanmaktadır.</p>
            <p>Mezoterapi ilaçları, endikasyona göre değişen çeşitli ilaç karışımları 5-10 dakika gibi bir süre içerisinde deri altına enjekte edilir.</p>
        </div>
    )
}

export default Mezoterapi